import NotFoundCard from 'components/NotFoundCard/NotFoundCard'
import styled from 'styled-components/macro'

/**
 * NotFoundContent - 404 page content for use inside AppLayout
 * This version doesn't include its own nav/footer since AppLayout provides those
 */
export function NotFoundContent() {
  return (
    <Container>
      <NotFoundCard />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 24px;
  background-color: #f5f5f5;

  /* Counteract ContentContainer padding in new nav layout for full-bleed background */
  [data-new-nav='true'] & {
    margin: calc(-1 * var(--page-container-vertical-padding));
    margin-bottom: calc(-1 * var(--page-container-bottom-padding));
  }
`
